import React, { useState, useEffect, useRef } from 'react'

import Form from 'react-bootstrap/Form'
import Title from './Title'

const Name = props => {
  const nameRef = useRef('')
  const [required, setRequired] = useState()
  const [focused, setFocused] = useState(false)
  const [changed, setChanged] = useState(false)

  useEffect(() => {
    setRequired(props.required)
    setChanged(false)
  }, [props.required])

  const validateField = () => {
    if (changed && nameRef.current.value === '') {
      setRequired(true)
      props.onSetValid(false)
    } else props.onSetValid(true)
  }

  const onFocus = e => {
    setFocused(true)
  }

  const onBlur = e => {
    setFocused(false)
    props.onBlur(nameRef.current.value)
  }

  const onChange = e => {
    setRequired(false)
    setChanged(true)
    validateField()
  }

  return (
    <Form.Group className='mb-3' controlId='Name'>
      <Title title='Name on card' required={required} />
      <Form.Control
        style={{
          borderColor: required && !focused && 'red'
        }}
        ref={nameRef}
        type='text'
        name='name'
        onFocus={onFocus}
        onChange={onChange}
        onBlur={onBlur}
        disabled={props.disabled}
      />
    </Form.Group>
  )
}

export default Name
